var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.00001C9.87772 5.12011 9.46953 4.30484 8.83832 3.67975C8.2071 3.05467 7.38788 2.65446 6.50684 2.54078C5.62579 2.4271 4.73181 2.60625 3.9626 3.05063C3.19339 3.49501 2.59162 4.17997 2.25 5.00001M2 3.00001V5.00001H4M2 7.00001C2.12228 7.8799 2.53047 8.69518 3.16168 9.32026C3.7929 9.94534 4.61212 10.3455 5.49316 10.4592C6.37421 10.5729 7.26819 10.3938 8.0374 9.94938C8.80661 9.505 9.40838 8.82004 9.75 8.00001M10 10V8.00001H8",
    stroke: "#4B33A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.9c12cf1a69885ecc02b003f9467c287a.svg";
export { ForwardRef as ReactComponent };